import { render, staticRenderFns } from "./CountriesView.vue?vue&type=template&id=8a168d3e"
import script from "./CountriesView.vue?vue&type=script&lang=js"
export * from "./CountriesView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports